import { createSlice } from '@reduxjs/toolkit'

export const connectStore = createSlice({
    name: 'connect-store',
    initialState: {
        // 是否连接
        isConnected: false,
        // 连接模式
        mode: null,
        deviceList: [],
        //检查更新
        checkExtension: false
    },
    reducers: {
        setConnectState: (state, action) => {
            state.isConnected = action.payload
        },
        setConnectionMode: (state, action) => {
            state.mode = action.payload
        },
        setDeviceList: (state, action) => {
            state.deviceList = action.payload
        },
        setCheckExtension: (state, action) => {
            state.checkExtension = action.payload
        }
    }
})

export const {
    setConnectState,
    setConnectionMode,
    setCheckExtension,
    setDeviceList
} = connectStore.actions
export default connectStore.reducer